"use strict";

exports.__esModule = true;
exports.HTTP_REQUEST_TIMEOUT = exports.SESSION_TIMEOUT = exports.OUTCOME_UNKNOWN = exports.OUTCOME_FAILURE = exports.OUTCOME_SUCCESS = exports.LAYOUT_SHIFT = exports.FIRST_INPUT = exports.TRUNCATED_TYPE = exports.ERROR_LOGGING = exports.PERFORMANCE_MONITORING = exports.APM_SERVER = exports.TRANSACTION_SERVICE = exports.LOGGING_SERVICE = exports.CONFIG_SERVICE = exports.TRANSACTIONS = exports.ERRORS = exports.TRANSACTION_TYPE_ORDER = exports.USER_INTERACTION = exports.TEMPORARY_TYPE = exports.KEYWORD_LIMIT = exports.LARGEST_CONTENTFUL_PAINT = exports.FIRST_CONTENTFUL_PAINT = exports.RESOURCE = exports.NAVIGATION = exports.MEASURE = exports.PAINT = exports.LONG_TASK = exports.HTTP_REQUEST_TYPE = exports.LOCAL_CONFIG_KEY = exports.AFTER_EVENT = exports.BEFORE_EVENT = exports.ERROR = exports.CLICK = exports.EVENT_TARGET = exports.HISTORY = exports.FETCH = exports.XMLHTTPREQUEST = exports.QUEUE_ADD_TRANSACTION = exports.QUEUE_FLUSH = exports.CONFIG_CHANGE = exports.TRANSACTION_END = exports.TRANSACTION_START = exports.USER_TIMING_THRESHOLD = exports.TYPE_CUSTOM = exports.NAME_UNKNOWN = exports.ROUTE_CHANGE = exports.PAGE_LOAD = exports.PAGE_LOAD_DELAY = exports.MAX_SPAN_DURATION = exports.REUSABILITY_THRESHOLD = exports.RESOURCE_INITIATOR_TYPES = exports.REMOVE_EVENT_LISTENER_STR = exports.ADD_EVENT_LISTENER_STR = exports.INVOKE = exports.SCHEDULE = void 0;
var SCHEDULE = 'schedule';
exports.SCHEDULE = SCHEDULE;
var INVOKE = 'invoke';
exports.INVOKE = INVOKE;
var ADD_EVENT_LISTENER_STR = 'addEventListener';
exports.ADD_EVENT_LISTENER_STR = ADD_EVENT_LISTENER_STR;
var REMOVE_EVENT_LISTENER_STR = 'removeEventListener';
exports.REMOVE_EVENT_LISTENER_STR = REMOVE_EVENT_LISTENER_STR;
var RESOURCE_INITIATOR_TYPES = ['link', 'css', 'script', 'img', 'xmlhttprequest', 'fetch', 'beacon', 'iframe'];
exports.RESOURCE_INITIATOR_TYPES = RESOURCE_INITIATOR_TYPES;
var REUSABILITY_THRESHOLD = 5000;
exports.REUSABILITY_THRESHOLD = REUSABILITY_THRESHOLD;
var MAX_SPAN_DURATION = 5 * 60 * 1000;
exports.MAX_SPAN_DURATION = MAX_SPAN_DURATION;
var PAGE_LOAD_DELAY = 1000;
exports.PAGE_LOAD_DELAY = PAGE_LOAD_DELAY;
var PAGE_LOAD = 'page-load';
exports.PAGE_LOAD = PAGE_LOAD;
var ROUTE_CHANGE = 'route-change';
exports.ROUTE_CHANGE = ROUTE_CHANGE;
var TYPE_CUSTOM = 'custom';
exports.TYPE_CUSTOM = TYPE_CUSTOM;
var USER_INTERACTION = 'user-interaction';
exports.USER_INTERACTION = USER_INTERACTION;
var HTTP_REQUEST_TYPE = 'http-request';
exports.HTTP_REQUEST_TYPE = HTTP_REQUEST_TYPE;
var TEMPORARY_TYPE = 'temporary';
exports.TEMPORARY_TYPE = TEMPORARY_TYPE;
var NAME_UNKNOWN = 'Unknown';
exports.NAME_UNKNOWN = NAME_UNKNOWN;
var TRANSACTION_TYPE_ORDER = [PAGE_LOAD, ROUTE_CHANGE, USER_INTERACTION, HTTP_REQUEST_TYPE, TYPE_CUSTOM, TEMPORARY_TYPE];
exports.TRANSACTION_TYPE_ORDER = TRANSACTION_TYPE_ORDER;
var OUTCOME_SUCCESS = 'success';
exports.OUTCOME_SUCCESS = OUTCOME_SUCCESS;
var OUTCOME_FAILURE = 'failure';
exports.OUTCOME_FAILURE = OUTCOME_FAILURE;
var OUTCOME_UNKNOWN = 'unknown';
exports.OUTCOME_UNKNOWN = OUTCOME_UNKNOWN;
var USER_TIMING_THRESHOLD = 60;
exports.USER_TIMING_THRESHOLD = USER_TIMING_THRESHOLD;
var TRANSACTION_START = 'transaction:start';
exports.TRANSACTION_START = TRANSACTION_START;
var TRANSACTION_END = 'transaction:end';
exports.TRANSACTION_END = TRANSACTION_END;
var CONFIG_CHANGE = 'config:change';
exports.CONFIG_CHANGE = CONFIG_CHANGE;
var QUEUE_FLUSH = 'queue:flush';
exports.QUEUE_FLUSH = QUEUE_FLUSH;
var QUEUE_ADD_TRANSACTION = 'queue:add_transaction';
exports.QUEUE_ADD_TRANSACTION = QUEUE_ADD_TRANSACTION;
var XMLHTTPREQUEST = 'xmlhttprequest';
exports.XMLHTTPREQUEST = XMLHTTPREQUEST;
var FETCH = 'fetch';
exports.FETCH = FETCH;
var HISTORY = 'history';
exports.HISTORY = HISTORY;
var EVENT_TARGET = 'eventtarget';
exports.EVENT_TARGET = EVENT_TARGET;
var CLICK = 'click';
exports.CLICK = CLICK;
var ERROR = 'error';
exports.ERROR = ERROR;
var BEFORE_EVENT = ':before';
exports.BEFORE_EVENT = BEFORE_EVENT;
var AFTER_EVENT = ':after';
exports.AFTER_EVENT = AFTER_EVENT;
var LOCAL_CONFIG_KEY = 'elastic_apm_config';
exports.LOCAL_CONFIG_KEY = LOCAL_CONFIG_KEY;
var LONG_TASK = 'longtask';
exports.LONG_TASK = LONG_TASK;
var PAINT = 'paint';
exports.PAINT = PAINT;
var MEASURE = 'measure';
exports.MEASURE = MEASURE;
var NAVIGATION = 'navigation';
exports.NAVIGATION = NAVIGATION;
var RESOURCE = 'resource';
exports.RESOURCE = RESOURCE;
var FIRST_CONTENTFUL_PAINT = 'first-contentful-paint';
exports.FIRST_CONTENTFUL_PAINT = FIRST_CONTENTFUL_PAINT;
var LARGEST_CONTENTFUL_PAINT = 'largest-contentful-paint';
exports.LARGEST_CONTENTFUL_PAINT = LARGEST_CONTENTFUL_PAINT;
var FIRST_INPUT = 'first-input';
exports.FIRST_INPUT = FIRST_INPUT;
var LAYOUT_SHIFT = 'layout-shift';
exports.LAYOUT_SHIFT = LAYOUT_SHIFT;
var ERRORS = 'errors';
exports.ERRORS = ERRORS;
var TRANSACTIONS = 'transactions';
exports.TRANSACTIONS = TRANSACTIONS;
var CONFIG_SERVICE = 'ConfigService';
exports.CONFIG_SERVICE = CONFIG_SERVICE;
var LOGGING_SERVICE = 'LoggingService';
exports.LOGGING_SERVICE = LOGGING_SERVICE;
var TRANSACTION_SERVICE = 'TransactionService';
exports.TRANSACTION_SERVICE = TRANSACTION_SERVICE;
var APM_SERVER = 'ApmServer';
exports.APM_SERVER = APM_SERVER;
var PERFORMANCE_MONITORING = 'PerformanceMonitoring';
exports.PERFORMANCE_MONITORING = PERFORMANCE_MONITORING;
var ERROR_LOGGING = 'ErrorLogging';
exports.ERROR_LOGGING = ERROR_LOGGING;
var TRUNCATED_TYPE = '.truncated';
exports.TRUNCATED_TYPE = TRUNCATED_TYPE;
var KEYWORD_LIMIT = 1024;
exports.KEYWORD_LIMIT = KEYWORD_LIMIT;
var SESSION_TIMEOUT = 30 * 60000;
exports.SESSION_TIMEOUT = SESSION_TIMEOUT;
var HTTP_REQUEST_TIMEOUT = 10000;
exports.HTTP_REQUEST_TIMEOUT = HTTP_REQUEST_TIMEOUT;


//////////////////
// WEBPACK FOOTER
// ./~/@elastic/apm-rum-core/dist/lib/common/constants.js
// module id = 14
// module chunks = 0